import type { ReactNode } from "react";
import { Logo } from "@freightsimple/ui-core/Display/Logo";

/**
 * Break-glass. The upload-photos page renders without the dashboard's nav or
 * page frame, and ui-core has no standalone-page primitive. A thin top bar
 * carries the logo the way the dashboard's signed-out bar does, lined up with
 * the content below. On a phone the content fills the screen with a small
 * gutter; from tablet width up it sits in one centred card on a soft
 * brand-tinted background, so nothing stretches edge to edge on a wide screen.
 * The card widens on a desktop to fit two columns.
 */
export function UploadPhotosPageSurface({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background sm:bg-brand-subtle">
      <header className="flex h-14 items-center border-b border-border bg-card px-4 sm:px-6">
        <div className="mx-auto w-full max-w-md lg:max-w-4xl">
          <div className="origin-left scale-[0.8]">
            <Logo />
          </div>
        </div>
      </header>
      <div className="px-4 py-4 sm:px-6 sm:py-6">
        <div className="mx-auto w-full max-w-md sm:rounded-2xl sm:bg-card sm:px-8 sm:pt-6 sm:pb-8 sm:shadow-lg sm:shadow-brand/10 lg:max-w-4xl">
          {children}
        </div>
      </div>
    </div>
  );
}
